import React, {  useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { addDays, format } from 'date-fns';

import { makeStyles } from '@material-ui/styles';
import { 
  Typography,
  Chip
  } 
  from '@material-ui/core';

import _ from 'lodash';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3)
  },
  spacer: {
    flexGrow: 1
  },
  selectButton: {
    marginLeft: theme.spacing(3)
  },
  datePiker:{
    marginRight: theme.spacing(3)

  },
  toggleButton:{
    marginRight: theme.spacing(3)

  },
  select:{
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3)

  }
}));


const Toolbar = props => {
  const { className,  ...rest } = props;

  const classes = useStyles();

  // const [selectedStartDate, setSelectedStartDate] = React.useState(new Date());
  // const [selectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [name, setName] = React.useState('');
  

  useEffect(() => {
    setName(props.heroname)
    // setSelectedEndDate(props.endDate)
  }, [props.heroname]);  


  const [meals, setMeals] = React.useState({
    today: {
      any: false,
      breakfast: false,
      dinner: false,
      supper: false
    },
    tomorrow: {
      any: false,
      breakfast: false,
      dinner: false,
      supper: false
    }
  });

  useEffect(() => {
    setMeals(props.meals)
    // setSelectedEndDate(props.endDate)
  }, [props.meals]);  


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
      <Typography variant="h3" component="h2" gutterBottom>
          Привет, {name}
      </Typography>
      </div>

      <div className={classes.row}>

      {/* Проверяем что заказ еще не сделан, есть ли еда на сегодня или нет */}
      { meals.today.any !== false && props.orderredy === 'false' &&
      <Typography variant="h5" component="h2" gutterBottom>
      На сегодня <b>{format(new Date(),'dd.MM.yyyy')}</b> выбран: {meals.today.breakfast ? <Chip size="medium" label="завтрак" color="primary" /> : ''} {meals.today.dinner ? <Chip size="medium" label="обед" color="primary" />: ''} {meals.today.supper ? <Chip size="medium" label="ужин" color="primary" />: ''}
      </Typography>
      }
      { meals.today.any !== true && props.orderredy === 'false' &&
      <Typography variant="h5" component="h2" gutterBottom>
      На сегодня <b>{format(new Date(),'dd.MM.yyyy')}</b> ничего не выбрано.
      </Typography>

      }
      {/* Если сделали заказ то показываем данные по новому заказу */}
      { meals.tomorrow.any !== false && props.orderredy === 'true' &&
      <Typography variant="h5" component="h2" gutterBottom>
          На <b>{format(props.todaycheck === 'true' ? new Date() : addDays(new Date(),1),'dd.MM.yyyy')}</b> выбран: {meals.tomorrow.breakfast ? <Chip size="medium" label="завтрак" color="primary" />: ''} {meals.tomorrow.dinner ? <Chip size="medium" label="обед" color="primary" />: ''} {meals.tomorrow.supper ? <Chip size="medium" label="ужин" color="primary" />: ''}
      </Typography>
      }
      </div>
      {/* Если не сделали заказ но на завтра есть еда, то показываем что есть на завтра */}
      { meals.tomorrow.any !== false && props.orderredy === 'false' &&
      <div className={classes.row}>
      <Typography variant="h5" component="h2" gutterBottom>
          На <b>{format(props.todaycheck === 'true' ? new Date() : addDays(new Date(),1),'dd.MM.yyyy')}</b> выбран: {meals.tomorrow.breakfast ? <Chip size="medium" label="завтрак" color="primary" />: ''} {meals.tomorrow.dinner ? <Chip size="medium" label="обед" color="primary" />: ''} {meals.tomorrow.supper ? <Chip size="medium" label="ужин" color="primary" />: ''}
      </Typography>
      </div>
      }
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
